<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
            <div class="form container px-2">
                <h5><b>A. PERSONAL DATA</b></h5>
                <div class="mb-4 mt-3">
                    <div>
                        <p class="mb-0"><b>A.1 &nbsp; &nbsp;Name (Surname Last):</b></p>
                    </div>
                    <div>
                        <input type="text" class="form-control pb-0" name="name" v-model="name" placeholder="e.g. John Doe">
                    </div>
                </div>

                <div class="mb-4 text-start">
                    <div>
                        <p class="mb-0"><b>A.2 &nbsp; &nbsp;Category of Staff:</b></p>
                    </div>
                    <select v-model="staffType" id="staffType"
                        name="Staff Type" @change="updateStaffType()" disabled>
                        <option selected value="Staff Type">Staff Type</option>
                        <option value="Academic Teaching">Academic Teaching Staff</option>
                        <option value="Research">Research Staff</option>
                        <option value="Library">Library Staff</option>
                        <option value="Senior Non-academic">Senior Non-academic Staff</option>
                        <option value="Junior Non-academic">Junior Non-academic Staff</option>
                    </select>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.3 &nbsp; &nbsp;File Number (SP. No.):</b></p>
                    </div>
                    <div>
                        <input type="text" class="form-control pb-0" name="fileNum" v-model="fileNum" placeholder="e.g. RSU/PF/SS/4226">
                    </div>
                </div>

                <div class="mb-4" v-if="isAcademicStaff">
                    <div>
                        <p class="mb-0"><b>A.4 &nbsp; &nbsp;Present status, grade level, and salary:</b></p>
                    </div>
                    <div class="text-start mt-2">
                        <div>
                            <select id="presentStatus" name="presentStatus" v-model="presentStatus" :disabled="candidate.submitted">
                                <option value="Professor">Professor</option>
                                <option value="Reader">Reader</option>
                                <option value="Senior Lecturer">Senior Lecturer</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="mb-4" v-if="isResearchStaff">
                    <div>
                        <p class="mb-0"><b>A.4 &nbsp; &nbsp;Present status, grade level, and salary:</b></p>
                    </div>
                    <div class="text-start mt-2">
                        <div>
                            <select id="presentStatus" name="presentStatus" v-model="presentStatus" :disabled="candidate.submitted">
                                <option value="Research Professor">Research Professor</option>
                                <option value="Research Reader">Research Reader</option>
                                <option value="Senior Research Fellow">Senior Research Fellow</option>
                                <option value="Research Fellow I">Research Fellow I</option>
                                <option value="Research Fellow II">Research Fellow II</option>
                                <option value="Assistant Research Fellow">Assistant Research Fellow</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="mb-4" v-if="isLibraryStaff">
                    <div>
                        <p class="mb-0"><b>A.4 &nbsp; &nbsp;Present status, grade level, and salary:</b></p>
                    </div>
                    <div class="text-start mt-2">
                        <div>
                            <select id="presentStatus" name="presentStatus" v-model="presentStatus" :disabled="candidate.submitted">
                                <option value="University Librarian">University Librarian</option>
                                <option value="Deputy Librarian">Deputy Librarian</option>
                                <option value="Principal Librarian">Principal Librarian</option>
                                <option value="Senior Librarian">Senior Librarian</option>
                                <option value="Librarian I">Librarian I</option>
                                <option value="Librarian II">Librarian II</option>
                                <option value="Assistant Librarian">Assistant Librarian</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.5 &nbsp; &nbsp;Faculty:</b></p>
                    </div>
                    <div class="text-start mt-2">
                        <select id="faculty" name="faculty" v-model="faculty" :disabled="candidate.submitted">
                            <option value="Agriculture" selected>Agriculture</option>
                            <option value="Basic Medical Sciences">Basic Medical Sciences</option>
                            <option value="Basic Clinical Sciences">Basic Clinical Sciences</option>
                            <option value="Clinical Sciences">Clinical Sciences</option>
                            <option value="Medical Laboratory Science">Medical Laboratory Science</option>
                            <option value="Communication and Media Studies">Communication and Media Studies</option>
                            <option value="Engineering">Engineering</option>
                            <option value="Education">Education</option>
                            <option value="Environmental Sciences">Environmental Sciences</option>
                            <option value="Humanities">Humanities</option>
                            <option value="Law">Law</option>
                            <option value="Administration and Management">Administration and Management</option>
                            <option value="Science">Science</option>
                            <option value="Social Sciences">Social Sciences</option>
                        </select>
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.6 &nbsp; &nbsp;Department:</b></p>
                    </div>
                    <div>
                        <input type="text" class="form-control pb-0" name="department" v-model="department" placeholder="e.g. Mechanical Engineering">
                    </div>
                </div>

                <!-- first employment -->
                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>
                            A.7 &nbsp; &nbsp;Date, status of level of First
                            Appointment in this University:
                        </b></p>
                    </div>
                    <div>
                        <textarea v-model="firstEmployment" type="text" class="form-control pb-0" rows="4" placeholder="e.g. 18 October 2019, Graduate Assistant, CONUASS 1/2"></textarea>
                    </div>
                </div>

                <!-- last employment -->
                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.8 &nbsp; &nbsp;Last change in status in this University with date:</b></p>
                    </div>

                    <div>
                        <textarea v-model="lastEmployment" type="text" class="form-control" rows="4" placeholder="e.g. Lecturer I, 1st October 2024."></textarea>
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>
                            A.9 &nbsp; &nbsp;Reference and date of notification concerning any more recent consideration of change in status:
                        </b></p>
                    </div>
                    <div>
                        <textarea id="statusNotification" v-model="statusNotification" type="text" class="form-control pb-0" rows="4" placeholder="e.g. Lecturer I, 1st October 2024."></textarea>
                    </div>
                </div>

                <div class="mb-5">
                    <div>
                        <p class="mb-0">
                            <b>
                                A.10 &nbsp; &nbsp;Date of confirmation of appointment:
                            </b>
                        </p>
                    </div>
                    <div class="mt-3">
                        <input v-model="confirmationDate" type="text" class="form-control picker" id="confirmationDate" placeholder="e.g. 23rd October, 2021" required>
                    </div>
                </div>

                <div class="d-flex flex-row-reverse pb-5">
                    <button @click="saveSection()" type="button" class="btn btn-success">Save & Continue</button>
                </div>
            </div>
        </div>
    </Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionA',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return {
            candidate: '',
            name: '',
            staffType: '',
            fileNum: '',
            presentStatus: '',
            faculty: '',
            department: '',
            firstEmployment: '',
            lastEmployment: '',
            statusNotification: '',
            confirmationDate: ''
        }
    },
    computed: {
        isAcademicStaff() {
            return this.$store.state.user.staffType == 'Academic Teaching'
        },
        isResearchStaff(){
            return this.$store.state.user.staffType == 'Research'
        },
        isLibraryStaff() {
            return this.$store.state.user.staffType == 'Library'
        },
    },
    mounted() {
        this.$emit('setSection', 'Section A');
        this.setData()
    },
    methods: {
        async saveSection() {
            this.$emit('toggleLoader');

            var dataDetails = {
                name: this.name,
                fileNum: this.fileNum,
                presentStatus: this.presentStatus,
                faculty: this.faculty,
                department: this.department,
                firstEmployment: this.firstEmployment,
                lastEmployment: this.lastEmployment,
                statusNotification: this.statusNotification,
                confirmationDate: this.confirmationDate
            }

            const candidate = await DataService.saveData(dataDetails)

            if (candidate) { 
                this.candidate = candidate;
                this.$router.push('/sectionb');
            }

            this.$emit('toggleLoader');
        },
        async updateStaffType() {
            this.$emit('toggleLoader');

            var dataDetails = {
                staffType: this.staffType
            }

            const user = await DataService.saveData(dataDetails)

            this.$emit('toggleLoader');

            if (user) {
                var token = JSON.parse(window.localStorage['user']).token
                this.$store.commit('connect', {_id: user._id, staffType: user.staffType, token: token});

                if (user.staffType == 'Academic Teaching' || user.staffType == 'Research' || user.staffType == 'Library') {
                    this.$router.push({ path: '/sectiona' });
                } else {
                    this.$router.push({ path: '/section1' })
                }
            }
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');
            
            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id)

            if (candidate) {
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate;
                this.name = candidate.name ? candidate.name : ''
                this.staffType = candidate.staffType ? candidate.staffType : ''
                this.fileNum = candidate.fileNum ? candidate.fileNum : ''
                this.presentStatus = candidate.presentStatus ? candidate.presentStatus : ''
                this.faculty = candidate.faculty ? candidate.faculty : ''
                this.department = candidate.department ? candidate.department : ''
                this.firstEmployment = candidate.firstEmployment ? candidate.firstEmployment : ''
                this.lastEmployment = candidate.lastEmployment ? candidate.lastEmployment : ''
                this.statusNotification = candidate.statusNotification ? candidate.statusNotification : ''
                this.confirmationDate = candidate.confirmationDate ? candidate.confirmationDate : ''
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>